<template>
  <div>
    <div class="help-block text-center">
      <span v-if="successfulVer == true">{{$t('pages.confirmEmail.success')}}</span>
      <span v-if="successfulVer == false">{{$t('pages.confirmEmail.fail')}}</span>
    </div>
  </div>
</template>

<script>
import Rest from './../../services/rest'

export default {
  data () {
    return {
      statusMsg: '',
      successfulVer: null
    }
  },
  props: ['token'],
  created () {
    return Rest.request('GET', `/users/verifyEmail/${this.token}`, (data) => {
      this.successfulVer = true
    }).catch(err => {
      this.successfulVer = false
      console.log(err)
    })
  },
  methods: {}
}
</script>



// WEBPACK FOOTER //
// ConfirmEmail.vue?037aeffc